import { useEffect } from 'react';
import { useAuthentication } from '../../auth/hooks/useAuthentication';
import { useGrippContext } from '../../grippContext';
import { SubscriptionClientProvider } from './subscriptionClientProvider';
import { SubscribePayload } from 'graphql-ws';

export const useSubscription = async (
  payload: SubscribePayload,
  onNewData: (data: any) => Promise<void>,
  enabled = true
) => {
  const { logger } = useGrippContext();
  const auth = useAuthentication();

  useEffect(() => {
    let unsubscribe = () => {};

    if (!auth || !auth.isAuthenticated || !auth.accessToken || !enabled) {
      return;
    }

    const client = SubscriptionClientProvider.getInstance(auth.accessToken);

    (async () => {
      const onNext = async (result: any) => {
        if (result?.errors?.length) {
          logger?.error(
            new Error(
              `GraphQL subscription error: ${result.errors
                .map((e: { message?: string }) => e?.message ?? 'unknown')
                .join(', ')}`
            )
          );
        }
        if (result?.data == null) {
          return;
        }
        try {
          await onNewData(result);
        } catch (err) {
          logger?.error(err);
        }
      };

      await new Promise((resolve, reject) => {
        unsubscribe = client.subscribe(payload, {
          next: (result) => {
            onNext(result).catch((err) => logger?.error(err));
          },
          error: (error) => {
            logger?.error(error);
            reject();
          },
          complete: () => resolve(null),
        });
      });
    })();

    return unsubscribe;
  }, [auth, enabled]);
};
